import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsFor() {
  return <section className="py-20 bg-cream" data-id="element-172">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-173">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-174">
          <FadeIn direction="right" data-id="element-175">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-sage/20 h-full" data-id="element-176">
              <h3 className="text-2xl font-bold text-brown mb-8 font-serif flex items-center gap-3" data-id="element-177">
                <div className="w-10 h-10 rounded-full bg-sage/20 flex items-center justify-center" data-id="element-178">
                  <Check className="w-5 h-5 text-sage" data-id="element-179" />
                </div>
                Esto es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-180">
                {['Madres con hijos de 0 a 5 años que se sienten desbordadas por los cambios constantes.', 'Mujeres que quieren criar con respeto pero no saben cómo poner límites claros.', 'Mamás que sienten que han perdido su identidad y su paz en el caos de la rutina.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-181">
                    <Check className="w-5 h-5 text-sage flex-shrink-0 mt-1" data-id="element-182" />
                    <span className="text-brown-light leading-relaxed" data-id="element-183">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-184">
            <div className="bg-white/50 p-8 md:p-10 rounded-3xl border border-cream-dark h-full" data-id="element-185">
              <h3 className="text-2xl font-bold text-brown/60 mb-8 font-serif flex items-center gap-3" data-id="element-186">
                <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center" data-id="element-187">
                  <X className="w-5 h-5 text-red-300" data-id="element-188" />
                </div>
                No es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-189">
                {['Personas que buscan métodos de castigo físico o autoritarismo rígido.', 'Quienes no están dispuestos a observar sus propias emociones primero.'].map((text, i) => <li key={i} className="flex items-start gap-4 opacity-70" data-id="element-190">
                    <X className="w-5 h-5 text-red-300 flex-shrink-0 mt-1" data-id="element-191" />
                    <span className="text-brown-light leading-relaxed" data-id="element-192">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}